export interface IMeState {
    known: boolean
}

export const initialMeState: IMeState = {
    known: false
}